import type { VaultKind } from '@onefootprint/request-types/dashboard';

// Shared reference for expiration timers
export const expirationTimers = {
  person: null as NodeJS.Timeout | null,
  business: null as NodeJS.Timeout | null,
};

export const clearExpirationTimer = (kind: VaultKind) => {
  const timerKey = kind === 'person' ? 'person' : 'business';
  if (expirationTimers[timerKey]) {
    clearTimeout(expirationTimers[timerKey]!);
    expirationTimers[timerKey] = null;
  }
};
